import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext, cloneElement } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import devWarning from '../_utils/devwarning';
import { toArray } from '../_utils/react-children';
import { Icon } from '../index';
import { Directions, Statuses, LabelPlacements } from './interface';
var Steps = function Steps(props) {
  var _context, _classNames, _context2;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps;
  var stepsProps = getCompProps('Steps', userDefaultProps, props);
  var direction = stepsProps.direction,
    initial = stepsProps.initial,
    _stepsProps$current = stepsProps.current,
    current = _stepsProps$current === void 0 ? 0 : _stepsProps$current,
    _stepsProps$status = stepsProps.status,
    status = _stepsProps$status === void 0 ? 'process' : _stepsProps$status,
    labelPlacement = stepsProps.labelPlacement,
    customPrefixcls = stepsProps.prefixCls,
    className = stepsProps.className,
    _stepsProps$style = stepsProps.style,
    style = _stepsProps$style === void 0 ? {} : _stepsProps$style,
    onChange = stepsProps.onChange,
    children = stepsProps.children,
    icons = stepsProps.icons,
    canClickCurrentStep = stepsProps.canClickCurrentStep,
    others = __rest(stepsProps, ["direction", "initial", "current", "status", "labelPlacement", "prefixCls", "className", "style", "onChange", "children", "icons", "canClickCurrentStep"]);
  devWarning(Directions.indexOf(direction) === -1, 'steps', "cannot found steps direction '".concat(direction, "'"));
  devWarning(Statuses.indexOf(status) === -1, 'steps', "cannot found steps status '".concat(status, "'"));
  devWarning(LabelPlacements.indexOf(labelPlacement) === -1, 'steps', "cannot found steps labelPlacement '".concat(labelPlacement, "'"));
  var stepsPrefixCls = getPrefixCls(prefixCls, 'steps', customPrefixcls); // 按钮样式前缀
  var stepsClassName = classNames(stepsPrefixCls, _concatInstanceProperty(_context = "".concat(stepsPrefixCls, "-")).call(_context, direction), className, (_classNames = {}, _defineProperty(_classNames, "".concat(stepsPrefixCls, "-leftLable"), labelPlacement === 'left'), _defineProperty(_classNames, "".concat(stepsPrefixCls, "-rightLable"), labelPlacement === 'right'), _defineProperty(_classNames, "".concat(stepsPrefixCls, "-bottomLable"), labelPlacement === 'bottom'), _defineProperty(_classNames, "".concat(stepsPrefixCls, "-topLable"), labelPlacement === 'top'), _classNames));
  var onStepClick = function onStepClick(next) {
    if (canClickCurrentStep || onChange && current !== next) {
      onChange(next);
    }
  };
  var getIcons = function getIcons() {
    var actualIcons = {};
    actualIcons.finish = icons && icons.finish || /*#__PURE__*/React.createElement(Icon, {
      type: "right-bold",
      className: "".concat(stepsPrefixCls, "-iconSize")
    });
    actualIcons.error = icons && icons.error || /*#__PURE__*/React.createElement(Icon, {
      type: "exclamatory",
      className: "".concat(stepsPrefixCls, "-iconSize")
    });
    return actualIcons;
  };
  var stepIcons = getIcons();
  return /*#__PURE__*/React.createElement("div", _extends({
    className: stepsClassName,
    style: style
  }, others), _mapInstanceProperty(_context2 = toArray(children)).call(_context2, function (child, index) {
    if (!child) return null;
    var stepNumber = initial + index;
    var childProps = _extends({
      stepNumber: "".concat(stepNumber + 1),
      stepIndex: stepNumber,
      key: stepNumber,
      prefixCls: stepsPrefixCls,
      icons: stepIcons,
      onStepClick: onChange && onStepClick,
      current: current
    }, child.props);
    if (!child.props.status) {
      if (stepNumber === current) {
        childProps.status = status;
      } else if (stepNumber < current) {
        childProps.status = 'finish';
      } else {
        childProps.status = 'wait';
      }
    }
    return /*#__PURE__*/cloneElement(child, childProps);
  }));
};
Steps.displayName = 'Steps';
export default Steps;